import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Modal from 'tg-modal';

const BurgerMenuLinkShape = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

const BurgerMenuLink = ({ href, title }) => <a href={href}>{title}</a>;

BurgerMenuLink.propTypes = BurgerMenuLinkShape;

class BurgerMenu extends Component {
    static propTypes = {
        links: PropTypes.arrayOf(
            PropTypes.shape({
                section: PropTypes.string.isRequired,
                items: PropTypes.arrayOf(PropTypes.shape(BurgerMenuLinkShape)).isRequired,
            }),
        ).isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            navbarClass: null,
        };
    }

    toggleModal = () => {
        // change the navbar class to make icons visible on a dark background
        const navbar = window.document.querySelector('.navbar');
        let { navbarClass } = this.state;
        if (this.state.navbarClass === null) {
            navbarClass = Array.prototype.find.call(
                navbar.classList,
                (cls) => cls === 'navbar-light' || cls === 'navbar-dark',
            );
            this.setState({
                navbarClass,
            });
        }
        const { isOpen } = this.state;
        if (isOpen) {
            // closing: return old class
            navbar.classList.replace('navbar-dark', navbarClass);
        } else {
            // opening: set the dark class
            navbar.classList.replace(navbarClass, 'navbar-dark');
        }

        this.setState({
            isOpen: !isOpen,
        });
    };

    render() {
        return (
            <div className="burger-menu__wrapper">
                <button
                    className={classNames('hamburger', 'hamburger--squeeze', { 'is-active': this.state.isOpen })}
                    onClick={this.toggleModal}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner" />
                    </span>
                </button>

                <Modal isOpen={this.state.isOpen} onCancel={this.toggleModal} isBasic isStatic dialogClassName="">
                    <div className="burger-menu__content">
                        <div className="burger-menu__background" />
                        <div className="burger-menu__options">
                            {this.props.links.map((section, index) => (
                                <div key={section.section} className={classNames({ 'mt-4': index > 0 })}>
                                    {section.items.map((link) => (
                                        <BurgerMenuLink href={link.href} title={link.title} key={link.title} />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default BurgerMenu;



// WEBPACK FOOTER //
// ./src/components/BurgerMenu.js